<div class="my-5 my-xl-8">
  <mwe-tooltip-card [iconClass]="'fas fa-map-marker-alt text-secondary-light'" [content]="meterPointAddress()" [hasTooltipBody]="false" />
</div>
<mwe-basic-card [cardTitle]="changeTypeText()" cardClass="ikp-basic-card-override" headingNodeType="h4">
  @for (product of productFields(); track product) {
    <hr class="my-5" />
    <lib-ikp-info-card-section
      [infoCardType]="InfoCardType.LINK"
      [truncateTitle]="false"
      [title]="'meterPoint.meterPointChangeRequest.summary.product.title'"
      [actionText]="isEditDisabled() ? null : 'meterPoint.meterPointChangeRequest.summary.editActionButton'"
      [actionColor]="'dark-blue'"
      [actionIcon]="'pen'"
      (actionClicked)="navigateToStepWithSubRoute(ROUTE_PRODUCTS_AND_DATE)"
    >
      <div class="row row-gap-3">
        @for (field of product; track field.contentDivId) {
          @if (field.label === null && field.value === null) {
            <div class="col-xl-6 col-0"></div>
          } @else {
            <lib-ikp-info-card-content-field
              class="col-xl-6 col-12"
              [key]="field.label"
              [value]="field.value"
              [contentDivId]="field.contentDivId"
            />
          }
        }
      </div>
    </lib-ikp-info-card-section>
  }
  <hr class="my-5" />
  <lib-ikp-info-card-section
    [infoCardType]="InfoCardType.LINK"
    [truncateTitle]="false"
    [title]="'meterPoint.meterPointChangeRequest.currentContractPartnerStep.cardTitle'"
    [actionText]="isEditDisabled() ? null : 'meterPoint.meterPointChangeRequest.summary.editActionButton'"
    [actionColor]="'dark-blue'"
    [actionIcon]="'pen'"
    (actionClicked)="navigateToStepWithSubRoute(ROUTE_CURRENT_CONTRACT_PARTNER)"
  >
    <div class="row row-gap-3">
      @if (wizardStore.state().currentContractPartner?.occupiedContractPartner.isContractPartnerDataKnown) {
        @for (field of currentPartnerFields(); track field.contentDivId) {
          @if (field.label === null && field.value === null) {
            <div class="col-xl-6 col-0"></div>
          } @else {
            <lib-ikp-info-card-content-field
              class="col-xl-6 col-12"
              [key]="field.label"
              [value]="field.value"
              [contentDivId]="field.contentDivId"
            />
          }
        }
      } @else {
        <span>{{ 'meterPoint.meterPointChangeRequest.summary.currentPartner.contractPartnerInfoNotAvailable' | translate }}</span>
      }
      @if (meterPoint()?.hasAbweichenderRechnungsempfaenger && isFromLeerstandChange()) {
        <span class="col-12 font-16 font-bold text-blue">
          {{ 'meterPoint.meterPointChangeRequest.currentContractPartnerStep.empty.differentInvoiceAddressReadonly' | translate }}
        </span>
        @for (field of currentPartnerAlternativeInvoicingFields(); track field.contentDivId) {
          <lib-ikp-info-card-content-field
            class="col-xl-6 col-12"
            [key]="field.label"
            [value]="field.value"
            [contentDivId]="field.contentDivId"
          />
        }
      }
    </div>
  </lib-ikp-info-card-section>
  <hr class="my-5" />
  <lib-ikp-info-card-section
    [infoCardType]="InfoCardType.LINK"
    [truncateTitle]="false"
    [title]="'meterPoint.meterPointChangeRequest.summary.newPartner.title'"
    [actionText]="isEditDisabled() ? null : 'meterPoint.meterPointChangeRequest.summary.editActionButton'"
    [actionColor]="'dark-blue'"
    [actionIcon]="'pen'"
    (actionClicked)="navigateToStepWithSubRoute(ROUTE_NEW_CONTRACT_PARTNER)"
  >
    <div class="row row-gap-3">
      @if (isToLeerstandChange()) {
        @if (neuerVertragspartnerType() === VertragspartnerSelectionType.EIGENES_UNTERNEHMEN) {
          <span class="font-16 font-bold text-blue">
            {{ 'meterPoint.meterPointChangeRequest.summary.newPartner.partnerTypeOwnCompany' | translate }}
          </span>
        } @else if (neuerVertragspartnerType() === VertragspartnerSelectionType.ALTERNATIVE_PARTNER) {
          <span class="font-16 font-bold text-blue">
            {{ 'meterPoint.meterPointChangeRequest.summary.newPartner.partnerTypeOther' | translate }}
          </span>
        }
      }
      @for (field of newPartnerFields(); track field.contentDivId) {
        @if (field.label === null && field.value === null) {
          <div class="col-xl-6 d-xl-flex d-none"></div>
        } @else {
          <lib-ikp-info-card-content-field
            class="col-xl-6 col-12"
            [key]="field.label"
            [value]="field.value"
            [contentDivId]="field.contentDivId"
          />
        }
      }
      @if (neuerVertragspartnerHasAltInvoicingAddress()) {
        @if (neuerVertragspartnerType() === VertragspartnerSelectionType.EIGENES_UNTERNEHMEN) {
          <span class="col-12 font-16 font-bold text-blue">
            {{ 'meterPoint.meterPointChangeRequest.alternativeInvoicingAddress' | translate }}
          </span>
        } @else if (neuerVertragspartnerType() === VertragspartnerSelectionType.ALTERNATIVE_PARTNER) {
          <span class="col-12 font-16 font-bold text-blue">
            {{ 'meterPoint.meterPointChangeRequest.summary.newPartner.addressOfAbweichenderRechnungsempfaenger' | translate }}
          </span>
        }
        @for (field of alternativeInvoicingFields(); track field.contentDivId) {
          @if (field.label) {
            <lib-ikp-info-card-content-field
              class="col-xl-6 col-12"
              [key]="field.label"
              [value]="field.value"
              [contentDivId]="field.contentDivId"
            />
          }
        }
      }
    </div>
  </lib-ikp-info-card-section>
  <hr class="my-5" />
  @switch (this.wizardStore.state().stepChangeType) {
    @case (MeterPointChangeType.OCCUPIED_TO_EMPTY) {
      <lib-ikp-info-card-section
        [infoCardType]="InfoCardType.LINK"
        [truncateTitle]="false"
        [title]="'meterPoint.meterPointChangeRequest.summary.contractualDeclaration.occupiedToEmpty.title'"
      >
        <div class="row row-gap-2">
          <p class="mb-0 font-size-14">
            {{ 'meterPoint.meterPointChangeRequest.summary.contractualDeclaration.occupiedToEmpty.declarationTexts.0' | translate }}
          </p>
          <p
            class="mb-0 font-size-14"
            [innerHTML]="
              'meterPoint.meterPointChangeRequest.summary.contractualDeclaration.occupiedToEmpty.declarationTexts.1' | translate | safeHtml
            "
          ></p>
        </div>
      </lib-ikp-info-card-section>
    }
    @default {
      <lib-ikp-info-card-section
        [infoCardType]="InfoCardType.LINK"
        [truncateTitle]="false"
        [title]="'meterPoint.meterPointChangeRequest.summary.contractualDeclaration.title'"
      >
        <div class="row row-gap-2">
          <strong class="mb-0">
            <span class="font-size-14">{{
              'meterPoint.meterPointChangeRequest.summary.contractualDeclaration.subtitle-blocks.0' | translate
            }}</span>
            <ul class="my-0">
              @for (subtitleBullet of subtitleBullets; track subtitleBullet) {
                <li class="font-size-14" [innerHTML]="subtitleBullet | safeHtml"></li>
              }
            </ul>
            <span class="font-size-14">{{
              'meterPoint.meterPointChangeRequest.summary.contractualDeclaration.subtitle-blocks.1' | translate
            }}</span>
          </strong>
          <p class="mb-0 font-size-14">
            {{ 'meterPoint.meterPointChangeRequest.summary.contractualDeclaration.declarationTexts.0' | translate }}
          </p>
          <p class="mb-0">
            <strong>{{ 'meterPoint.meterPointChangeRequest.summary.contractualDeclaration.declarationTexts.1' | translate }}</strong>
          </p>
          <p
            class="mb-0 font-size-14"
            [innerHTML]="'meterPoint.meterPointChangeRequest.summary.contractualDeclaration.declarationTexts.2' | translate | safeHtml"
          ></p>
        </div>
      </lib-ikp-info-card-section>
    }
  }
  <hr class="my-5" />
  <lib-ikp-info-card-section
    [infoCardType]="InfoCardType.LINK"
    [truncateTitle]="false"
    [title]="'meterPoint.meterPointChangeRequest.summary.pdfDownload.title'"
  >
    <p class="mb-0">{{ 'meterPoint.meterPointChangeRequest.summary.pdfDownload.description' | translate }}</p>
    @if (isDownloadWarningShown()) {
      <mwe-inline-notification
        type="danger"
        titleKey="meterPoint.meterPointChangeRequest.summary.pdfDownload.infoBoxNotDownloadedTitle"
        messageKey="meterPoint.meterPointChangeRequest.summary.pdfDownload.infoBoxNotDownloadedText"
        class="mt-4 ml-lg-6 mt-lg-0"
      />
    }
    <div class="mt-5">
      <mwe-button
        [title]="'meterPoint.meterPointChangeRequest.summary.pdfDownload.downloadButton' | translate"
        [showHoverEffect]="true"
        (clicked)="downloadPdf()"
        labelKey="meterPoint.meterPointChangeRequest.summary.pdfDownload.downloadButton"
        class="d-block"
        category="primary"
        [showSpinner]="isPDFDownloading()"
        [disabled]="isPDFDownloading()"
      />
    </div>
  </lib-ikp-info-card-section>
</mwe-basic-card>
